"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var __1 = require("../../../..");
var ProfilTabs_1 = __importDefault(require("../../../Tab/ProfilTabs"));
var utils_1 = require("../Pomucky/utils");
var UkonyPrehledy_1 = __importDefault(require("./UkonyPrehledy"));
var UkonyStatistiky_1 = __importDefault(require("./UkonyStatistiky"));
var ContentDiv = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin: 0 3rem;\n  margin-bottom: 2em;\n"], ["\n  margin: 0 3rem;\n  margin-bottom: 2em;\n"])));
var DetailUkony = function (_a) {
    var idTlumocnik = _a.idTlumocnik, druhOsoby = _a.druhOsoby;
    var _b = react_1.useState('nezpracovano'), activeTab = _b[0], setActiveTab = _b[1];
    var token = __1.useToken();
    var _c = (token === null || token === void 0 ? void 0 : token.getDataFromToken()) || {}, roleIds = _c.roleIds, entityId = _c.entityId;
    var showPrehledy = __1.useBoolean(false);
    var showStatistiky = __1.useBoolean(false);
    if (!showPrehledy.value &&
        (((roleIds === null || roleIds === void 0 ? void 0 : roleIds.includes(__1.Role.tlumocnik)) && entityId === idTlumocnik.toString()) || (roleIds === null || roleIds === void 0 ? void 0 : roleIds.includes(__1.Role.Editor)) || (roleIds === null || roleIds === void 0 ? void 0 : roleIds.includes(__1.Role.Spravce)) || (roleIds === null || roleIds === void 0 ? void 0 : roleIds.includes(__1.Role.nahlizejici)))) {
        showPrehledy.setTrue();
    }
    if (!showStatistiky.value &&
        (((roleIds === null || roleIds === void 0 ? void 0 : roleIds.includes(__1.Role.tlumocnik)) && entityId === idTlumocnik.toString()) || (roleIds === null || roleIds === void 0 ? void 0 : roleIds.includes(__1.Role.Editor)) || (roleIds === null || roleIds === void 0 ? void 0 : roleIds.includes(__1.Role.nahlizejici)))) {
        showStatistiky.setTrue();
    }
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(utils_1.StyledH2, { isDetail: true },
            "Evidence ",
            druhOsoby === __1.TlumocniciDruhOsoby.tlumocnik ? 'tlumočnických' : 'překladatelských',
            " \u00FAkon\u016F"),
        react_1.default.createElement(ContentDiv, null, !showPrehledy.value ? (react_1.default.createElement(UkonyStatistiky_1.default, { idTlumocnik: idTlumocnik })) : (react_1.default.createElement(ProfilTabs_1.default, { activeId: activeTab, onSelect: setActiveTab },
            react_1.default.createElement(ProfilTabs_1.default.Tab, { id: "nezpracovano", title: "DOSUD NEPROVEDEN\u00C9 \u00DAKONY" },
                react_1.default.createElement(UkonyPrehledy_1.default, { idTlumocnik: idTlumocnik, zpracovano: false })),
            react_1.default.createElement(ProfilTabs_1.default.Tab, { id: "zpracovano", title: "PROVEDEN\u00C9 \u00DAKONY" },
                react_1.default.createElement(UkonyPrehledy_1.default, { idTlumocnik: idTlumocnik, zpracovano: true })),
            react_1.default.createElement(ProfilTabs_1.default.Tab, { id: "statistika", title: "P\u0158EHLEDY" },
                react_1.default.createElement(UkonyStatistiky_1.default, { showPrivate: showStatistiky.value, idTlumocnik: idTlumocnik })))))));
};
exports.default = DetailUkony;
var templateObject_1;
